import { axiosInstance } from '../../api';
const BASE_PATH = '/common';


//Get All CV Reviewers API Call
export let getAllCompanyUsers = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_all_company_users')
        return value
    } catch (error) {
        return error
    }
}
